export default {
    chartOptions: state => state.chartOptions,
    dashboardReport: state => state.dashboardReport,
    chartReport: state => state.chartReport
}
